import React, { useState } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with show/hide toggle (eye icon).
 * Forwards all standard input props (value, onChange, name, autoComplete, etc.).
 */
export default function PasswordInput({ className = '', 'data-testid': testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        type={show ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-2 flex items-center text-muted-foreground hover:text-foreground transition-colors"
        aria-label={show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
